import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import useFormProcessor from '../../hooks/useFormProcessor';

import { setCookie } from '../../utils/cookie';
import { registerUser,getCaptcha } from '../../services/users.service';

import { Context } from '../../providers/global-context.provider';
import {
	validatePassword,
	validateConfirmPassword,
	validateUsername,
	validateEmail,
	validateFirstName,
	validateLastName,
	validateMobile
} from '../../utils/validations/auth';
import { getServerErrorsObject, getEmptyInputsErrorsObject } from '../../utils/errors/auth';
import ErrorMessageContainer from '../form-input-error-message';
import FormInput from '../form-input';
import FormButton from '../button-form';

const initialUser = {
	firstName: '',
	lastName: '',
	username: '',
	Email: '',
	password: '',
	confirmPassword: '',
	mobile: '',
	Version: 'V2',
	captchaText: '',
	captchaToken: '',
	captchaImgUrl: '',
	captchaInputText: '',
	message: '',
};

const SignUpForm = ({ classes, ...otherProps }) => {
	const { data, errors, setErrors, handleChange, handleOnBlur, handleSubmit, setData } = useFormProcessor({}, initialUser);
	const { toggleLoggedIn, saveUser } = useContext(Context);
	const history = useHistory();

	const handleSignUp = async () => {

		const { firstName, lastName, username, Email, password ,mobile ,captchaText ,captchaToken ,captchaInputText,Version } = data;
		const result = await registerUser({ firstName, lastName, username, Email, password ,mobile ,captchaText ,captchaToken ,captchaInputText,Version });

		if(!result) {
			// setErrors({ errors, 'خطا در ارتباط با سرور' });
		}else if (result.Status && result.Status == 1) {
			// console.log(result.User);
			saveUser(result.Data.User);
			setCookie('x-auth-token', result.AccessToken);
			toggleLoggedIn(true);
			setErrors(initialUser);
			history.push('/user/projects');
		} else {
			await doRefresh();
			const errorsObject = getServerErrorsObject(result);
			setErrors({ ...errors, ...errorsObject });
		}
	};

	
	const doRefresh = async () => {
		const res = await getCaptcha();

		setData({ ...data, captchaText: res.CaptchaTextValue, captchaToken: res.CaptchaTokenValue, captchaImgUrl: res.CaptchaImgUrl, version: 'V2' });
		setErrors({ ...errors, captchaText: '', captchaImgUrl: '', captchaToken: '' });

	};

	return (
		<form
			onSubmit={(e) => {setData({ ...data, message: '' });setErrors({ ...errors, message: '' }); getEmptyInputsErrorsObject({ ...data }); handleSubmit(e, getEmptyInputsErrorsObject({ ...data }), handleSignUp)}}
			className={`lg:w-2/6 md:w-1/2 rounded-lg p-8 flex flex-col md:ml-0 w-full mt-10 md:mt-0 ${classes}`}
			{...otherProps}
		>
			<h2 className="text-gray-900 text-lg font-medium title-font mb-5">ثبت نام اعضای تیم</h2>
			<FormInput
				type="text"
				name="firstName"
				value={data.firstName}
				placeholder="نام"
				handleOnBlur={(event) => handleOnBlur(event, validateFirstName, { firstName: data.firstName })}
				handleChange={handleChange}
			/>
			{errors.firstName ? <ErrorMessageContainer>{errors.firstName}</ErrorMessageContainer> : null}

			<FormInput
				type="text"
				name="lastName"
				value={data.lastName}
				placeholder="نام خانوادگی"
				handleOnBlur={(event) => handleOnBlur(event, validateLastName, { lastName: data.lastName })}
				handleChange={handleChange}
			/>
			{errors.lastName ? <ErrorMessageContainer>{errors.lastName}</ErrorMessageContainer> : null}

			<FormInput
				type="text"
				name="username"
				value={data.username}
				placeholder="نام کاربری (کد ملی شما)"
				handleOnBlur={(event) => handleOnBlur(event, validateUsername, { username: data.username })}
				handleChange={handleChange}
			/>
			{errors.username ? <ErrorMessageContainer>{errors.username}</ErrorMessageContainer> : null}


			<FormInput
				type="mobile"
				name="mobile"
				value={data.mobile}
				placeholder="شماره تلفن همراه معتبر"
				handleOnBlur={(event) => handleOnBlur(event, validateMobile, { mobile: data.mobile })}
				handleChange={handleChange}
			/>
			{errors.mobile ? <ErrorMessageContainer>{errors.mobile}</ErrorMessageContainer> : null}

			<FormInput
				type="Email"
				name="Email"
				value={data.Email}
				placeholder="ایمیل معتبر"
				handleOnBlur={(event) => handleOnBlur(event, validateEmail, { Email: data.Email })}
				handleChange={handleChange}
			/>
			{errors.Email ? <ErrorMessageContainer>{errors.Email}</ErrorMessageContainer> : null}

			<FormInput
				type="password"
				name="password"
				value={data.password}
				placeholder="رمزعبور"
				handleOnBlur={(event) => handleOnBlur(event, validatePassword, { password: data.password })}
				handleChange={handleChange}
			/>
			{errors.password ? <ErrorMessageContainer>{errors.password}</ErrorMessageContainer> : null}

			<FormInput
				type="password"
				name="confirmPassword"
				value={data.confirmPassword}
				placeholder="تکرار رمز عبور"
				handleOnBlur={(event) =>
					handleOnBlur(event, validateConfirmPassword, {
						password: data.password,
						confirmPassword: data.confirmPassword
					})}
				handleChange={handleChange}
			/>
			{errors.confirmPassword ? <ErrorMessageContainer>{errors.confirmPassword}</ErrorMessageContainer> : null}

			<div className="row">
				<div className="col-4"></div>
				<img src={data.captchaImgUrl}
					className="mb-4" />
				<a className="fa fa-refresh btn-sm cursor-pointer"
                	onClick={doRefresh}></a>

			</div>
			<FormInput
				type="number"
				name="captchaInputText"
				placeholder="لطفا کد را وارد کنید"
				value={data.captchaInputText}
				handleChange={handleChange}
			/>
			{errors.captchaInputText ? <ErrorMessageContainer>{errors.captchaInputText}</ErrorMessageContainer> : null}
			<input type="hidden" name="Version" id="version" value={data.Version} />

			{errors.message ? <ErrorMessageContainer>{errors.message}</ErrorMessageContainer> : null}
			<FormButton addClass="mt-4">ثبت نام</FormButton>
		</form>
	);
};

export default SignUpForm;
